import {request} from '@/utils/request'
import CacheUtil from '@/utils/cache'

// 获取首页一级分类（带缓存）
export function getHomeOneCateList(data, useCache = true, expire = 1800) {
    const cacheKey = `home_one_cate_list_${JSON.stringify(data || {})}`;

    // 如果启用缓存且缓存存在，直接返回缓存数据
    if (useCache) {
        const cachedData = CacheUtil.get(cacheKey);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
    }

    // 发起API请求
    return request({
        url: '/chemicals/getHomeOneCateList',
        method: 'get',
        data
    }).then(res => {
        // 如果启用缓存且请求成功，缓存数据
        if (useCache && res.data && res.data.code === 10000) {
            CacheUtil.set(cacheKey, res, expire);
        }
        return res;
    });
}

// 获取二级分类
export function getHomeTwoCateList(id) {
    return request({
        url: '/chemicals/getHomeTwoCateList/' + id,
        method: 'get'
    })
}

// 获取二级分类
export function getHomeTwoCateListApi(data) {
    return request({
        url: '/shop/product/listApi',
        method: 'get',
        data
    })
}

// 前台获取产品列表
export function getList(data) {
    return request({
        url: '/chemicals/getList',
        method: 'get',
        data
    })
}

// 实时求购
export function online_purchase(data) {
    return request({
        url: '/purchase/online_purchase',
        method: 'get',
        data
    })
}


// 实时求购
// export function online_purchase(data, useCache = true, expire = 1800) {
//     const cacheKey = `online_purchase${JSON.stringify(data || {})}`;
//
//     // 如果启用缓存且缓存存在，直接返回缓存数据
//     if (useCache) {
//         const cachedData = CacheUtil.get(cacheKey);
//         if (cachedData) {
//             return Promise.resolve(cachedData);
//         }
//     }
//
//     return request({
//         url: '/purchase/online_purchase',
//         method: 'get',
//         data
//     }).then(res => {
//         // 如果启用缓存且请求成功，缓存数据
//         if (useCache && res.data && res.data.code === 10000) {
//             if (res.data.data.data.length !== 0) {
//                 CacheUtil.set(cacheKey, res, expire);
//             }
//         }
//         return res;
//     });
// }

// 获取企业荣誉/企业资质
export function getCompanyInfo(type) {
    return request({
        url: '/system/getCompanyInfo/' + type,
        method: 'get',
    })
}

// 物流查询
export function express(id) {
    return request({
        url: '/order/express/' + id,
        method: 'get',
    })
}

// 实时成交
export function online_deal(data) {
    return request({
        url: '/order/online_deal',
        method: 'get',
        data
    })
}

// 实时成交
export function getMallChoice(data) {
    return request({
        url: '/shop/getMallChoice',
        method: 'get',
        data
    })
}

// 优质供应商
export function getGoodSupplierList(data) {
    return request({
        url: '/system/getGoodSupplierList',
        method: 'get',
        data
    })
}

// 获取行业工具分类
export function getToolCateList(data) {
    return request({
        url: '/system/getToolCateList',
        method: 'get',
        data
    })
}

// 获取行业工具
export function getToolList(id, data) {
    return request({
        url: '/system/getToolList/' + id,
        method: 'get',
        data
    })
}

// 获取原料供应专区
export function supplyZone(data) {
    return request({
        url: '/supply/supplyZone',
        method: 'get',
        data
    })
}

// 获取化联网咨询列表
export function getNewsList(data) {
    return request({
        url: '/news/getNewsList',
        method: 'get',
        data
    })
}

// 获取化联网咨询详情
export function getNewsDetail(id, data) {
    return request({
        url: '/news/detail/' + id,
        method: 'get',
        data
    })
}

// 获取热门资讯
export function getHotNews(data) {
    return request({
        url: '/news/getHotNews',
        method: 'get',
        data
    })
}

// 获取企业新闻
export function getQiyeNews(data) {
    return request({
        url: '/news/getQiyeNews',
        method: 'get',
        data
    })
}

// 获取商城分类列表
export function getMallCategoryListAtApi(data) {
    return request({
        url: '/shop/getMallCategoryListAtApi',
        method: 'get',
        data
    })
}

// 商城分类获取商品列表
export function listApi(data) {
    return request({
        url: '/shop/product/listApi',
        method: 'get',
        data
    })
}

// 技术列表
export function tech_list_api(data) {
    return request({
        url: '/tech/tech_list_api',
        method: 'get',
        data
    })
}

// 技术详情
export function tech_detail(id, data) {
    return request({
        url: '/tech/tech_detail/' + id,
        method: 'get',
        data
    })
}

// 商品详情
export function detailApi(id, data) {
    return request({
        url: '/shop/product/detailApi/' + id,
        method: 'get',
        data
    })
}

// 加入购物车
export function shop_cart(data) {
    return request({
        url: '/order/shop_cart',
        method: 'post',
        data
    })
}

// 首页来料加工
export function proces_list(type, data) {
    return request({
        url: '/proces/proces_list/' + type,
        method: 'get',
        data
    })
}

// 首页来料加工详情
export function proces_detail(id, data) {
    return request({
        url: '/proces/proces_detail/' + id,
        method: 'get',
        data
    })
}

// 首页聊天列表
export function chat_list(data) {
    return request({
        url: '/system/chat_list',
        method: 'get',
        data
    })
}

// 获取购物车列表
export function shop_cart_list() {
    return request({
        url: '/order/shop_cart',
        method: 'get',
    })
}

// 删除购物车商品
export function shop_cart_delete(id) {
    return request({
        url: '/order/shop_cart/' + id,
        method: 'delete',
    })
}
